import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { translate } from '@application/common/helpers/translate';
import { forgotPasswordAsync } from '@application/features/auth/authThunks';
import { useAppDispatch } from '@application/store/useStore';
import VnValidation from '@ui/components/VnValidation';
import { Controller, useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
const ForgotPassword = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { control, handleSubmit, formState: { errors } } = useForm();
    const onSubmit = (input) => {
        dispatch(forgotPasswordAsync(input))
            .unwrap()
            .then(() => {
            navigate('/login');
        })
            .catch((error) => { });
    };
    return (_jsxs("div", { className: 'auth-form-container', children: [_jsx("img", { src: 'images/loginBackgroundImage.png', alt: '', className: 'loginBackground' }), _jsx("form", { onSubmit: handleSubmit(onSubmit), id: 'contact-form', noValidate: true, className: 'auth-form', children: _jsxs("div", { className: 'auth-form-content', children: [_jsx("div", { className: 'login-icon', children: _jsx("img", { src: 'images/MainLogo.png', alt: '', className: 'vn-login-logo' }) }), _jsxs("div", { className: 'form-group mt-5', children: [_jsx("label", { className: 'emailLabel', children: "E-mail" }), _jsx(Controller, { name: 'email', control: control, rules: {
                                        required: {
                                            value: true,
                                            message: translate('validations.fieldIsRequired')
                                        },
                                        pattern: {
                                            value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                            message: 'Ongeldig e-mailadres'
                                        }
                                    }, render: ({ field: { onChange, value } }) => (_jsx("input", { type: 'email', name: 'email', placeholder: 'Voer e-mailadres in', className: 'form-control mt-1', onChange: onChange, value: value })) }), _jsx(VnValidation, { fieldError: errors.email })] }), _jsx("div", {}), _jsx("div", { className: 'd-grid gap-2 mt-4', children: _jsx("button", { type: 'submit', name: 'submit__form', className: 'submitButton', children: "Indienen" }) })] }) })] }));
};
export default ForgotPassword;
